export enum IframeIdsEnumeration {
  ACCOUNT_CHECK = 'ACCOUNT_CHECK',
  OPENBANKING = 'OPENBANKING',
  TGSS = 'TGSS',
  UPLOAD_ID = 'UPLOAD_ID',
  VIDEOSELFIE = 'VIDEOSELFIE',
}
